import { useState } from "react";

import { ErrorDisplay } from "../ErrorDisplay";

interface VideoPlayerProps {
  dataUrl: string;
}

export const VideoPlayer = ({ dataUrl }: VideoPlayerProps) => {
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="space-y-3">
      <div className="text-sm font-medium">Video Player</div>

      {error && <ErrorDisplay title="Failed to load video" message={error} />}

      <div className="relative">
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center rounded bg-gray-100">
            <div className="text-sm text-gray-600">Loading video...</div>
          </div>
        )}
        <video
          src={dataUrl}
          controls
          className="h-auto w-full rounded object-contain"
          style={{
            maxWidth: "100%",
            maxHeight: "400px",
          }} // eslint-disable-next-line @typescript-eslint/no-unused-vars
          onError={e => {
            setIsLoading(false);
            setError(
              "Unable to load video. The file may be corrupted or the browser doesn't support this video format.",
            );
          }}
          onLoadStart={() => {
            setError(null);
            setIsLoading(true);
          }}
          onCanPlay={() => {
            setIsLoading(false);
            setError(null);
          }}
          onLoadedData={() => {
            setIsLoading(false);
          }}
        >
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};
